import { useContext } from "react";

import { AuthContext } from "../components/auth";

export function useAuthContext() {
  return useContext(AuthContext);
}
